module.exports = __webpack_public_path__ + "static/media/WhitneySSm-Black-Adv_Web.b5186d15.woff";